<template>
    <v-app light>

        <v-navigation-drawer
        persistent
        :mini-variant="miniVariant"
        :clipped="clipped"
        v-model="drawer"
        enable-resize-watcher
        app
        >

                <v-toolbar class="primary" dark>
                    <v-toolbar-title v-if="!miniVariant">Navigation</v-toolbar-title>
                    <v-spacer v-if="!miniVariant"></v-spacer>
                    <v-btn icon v-if="!miniVariant" @click="drawer = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-list v-if="miniVariant">
                        <v-list-tile @click="drawer = false">
                            <v-list-tile-action>
                                <v-icon class="white--text">close</v-icon>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                </v-toolbar>

        <v-list>
            <v-list-tile
            v-for="(item, i) in items"
            :key="i"
            :to="item.to"
            ripple
            :exact="item.exact"
            >
                <v-list-tile-action>
                    <v-icon light>{{item.icon}}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title v-text="item.title"></v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
        </v-navigation-drawer>
        <v-toolbar fixed app :clipped-left="clipped" class="primary" dark>
        <v-toolbar-side-icon v-if="!drawer" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-btn
            icon
            @click.stop="miniVariant = !miniVariant"
        >
            <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
        </v-btn>
        <v-btn
            icon
            @click.stop="clipped = !clipped"
        >
            <v-icon>web</v-icon>
        </v-btn>
        <v-btn
            icon
            @click.stop="fixed = !fixed"
        >
            <v-icon>remove</v-icon>
        </v-btn>
        <v-toolbar-title v-text="title"></v-toolbar-title>
        <v-spacer></v-spacer>

        </v-toolbar>
        <main>
        <v-content>
            <v-container fluid class="pa-0">
            <v-slide-y-transition mode="out-in">
                <v-layout column align-center>
                    <v-slide-x-transition>                        
                        <router-view></router-view>              
                    </v-slide-x-transition>
                </v-layout>
            </v-slide-y-transition>
            </v-container>
        </v-content>
        </main>
        <v-footer :fixed="fixed" app>
        <span>&copy; 2017</span>
        </v-footer>
    </v-app>
</template>

<script>
export default {
  data() {
    return {
      clipped: false,
      fixed: false,
      drawer: false,
      items: [
        { icon: 'home', title: 'Home', to: '/', exact: true },
        { icon: 'person', title: 'Profile', to: '/index/profile', exact: true },
        { icon: 'code', title: 'Portfolio', to: '/index/portfolio', exact: false },
      ],
      miniVariant: false,
      right: true,
      title: 'J. Hermosilla',
    };
  },
};
</script>


// WEBPACK FOOTER //
// Content.vue?0a1614e6